export const isFilterValueActive = (value: unknown): boolean => {
    if (value === null || value === undefined) return false;
    if (Array.isArray(value)) return value.some((item) => isFilterValueActive(item));
    if (typeof value === 'string') return value.trim().length > 0;

    return true;
};
